import { render } from "./NewTDAAddParticipant.vue?vue&type=template&id=2aeb80e5"
import script from "./NewTDAAddParticipant.vue?vue&type=script&lang=js"
export * from "./NewTDAAddParticipant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__